import {TransactionUtility} from '../utility/transaction.utility';
import {MosaicUtility} from '../utility/mosaic.utility';
import {MetadataUtility} from '../utility/metadata.utility';

export const CATAPULT_UTILITY_PROVIDERS = [
  TransactionUtility,
  MosaicUtility,
  MetadataUtility
];
